// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3zXLn","actions":"GroupTable_actions__32G_0","deleteModalFooter":"GroupTable_deleteModalFooter__3KuBK"};